export const CLIC_DROIT = 'Clic_droit'
export const AFFICHER_ADRESSE = 'Afficher_l_adresse'
export const AFFICHER_VILLE = 'Afficher_la_ville'
export const AFFICHER_DEPARTEMENT = 'Afficher_le_departement'
export const AFFICHER_REGION = 'Afficher_la_region'
export const ITINERAIRE_DEPUIS = 'Itinéraire_depuis_ce_lieu'
export const ITINERAIRE_VERS = 'Itinéraire_vers_ce_lieu'
export const AJOUTER_ETAPE = 'Ajouter_une_etape_ici'
